import request from '@/utils/request'

// 租户场地
export function findTenantServicePlace(params) {
  return request({
    url: '/tenant/service_place',
    method: 'get',
    params: params
  })
}
